import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
    return (
        <>
            <div className="sticky_footer unveil sticky_footer_active" style={{marginBottom:0}}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-sm-6 col-xs-6 numbox" style={{marginBottom:0}}>
                            <a href="tel:+919920341097">
                                <span className="icon-wrap"><img data-src="assets/img/call.png" className="img-responsive" alt="telephone"
                                    src="assets1/img/call.png" style={{opacity: 1}}/></span>
                                <span className="number">+91-9920-341-097</span>
                            </a>
                        </div>
                        <div className="col-md-6 col-sm-6 col-xs-6 numbox">
                            {/* <!--<a href="whatsapp://send?abid=8097601177&text=Hello">--> */}
                                <a href=" https://api.whatsapp.com/send?phone=+919920341097&amp;text=Hello">

                                    <span className="icon-wrap"><img data-src="assets/img/whatsapp.png" className="img-responsive"
                                        alt="telephone" src="assets1/img/whatsapp.png" style={{opacity: 1}}/></span>
                                    <span className="number">+91-9920-3410-97</span>
                                </a>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!--footer section start--> */}
            <footer className="footer-section">
                {/* <!--footer top start--> */}
                <div className="footer-top gradient-bg">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-9">
                                <div className="row footer-top-wrap">
                                    <div className="col-md-4 col-sm-6">
                                        <div className="footer-nav-wrap text-white">
                                            <h3 className="text-white">Octave Infosys</h3>
                                            <p>We are Creative Team located in Mulund, Mumbai. We offer the best rate in web designing and development which is cost effective, superior in quality</p>
                                            <div className="social-nav mt-4">
                                                <ul className="list-unstyled social-list mb-0">
                                                    <li className="list-inline-item tooltip-hover">
                                                        <a href="https://www.facebook.com/octaveinfosys" rel="noreferrer" className="rounded"><span className="ti-facebook"></span></a>
                                                        <div className="tooltip-item">Facebook</div>
                                                    </li>
                                                    <li className="list-inline-item tooltip-hover">
                                                        <a href="https://twitter.com/InfosysOctave" rel="noreferrer" className="rounded"><span
                                                            className="ti-twitter"></span></a>
                                                        <div className="tooltip-item">Twitter</div>
                                                    </li>
                                                    <li className="list-inline-item tooltip-hover"><a href="https://www.linkedin.com/company/octave-infosys/" rel="noreferrer" className="rounded"><span
                                                        className="ti-linkedin"></span></a>
                                                        <div className="tooltip-item">Linkedin</div>
                                                    </li>
                                                    <li className="list-inline-item tooltip-hover"><a href="!#" className="rounded"><span
                                                        className="ti-dribbble"></span></a>
                                                        <div className="tooltip-item">Dribbble</div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 col-sm-6">
                                        <div className="footer-nav-wrap text-white">
                                            <h4 className="text-white">Quick Links</h4>
                                            <ul className="nav flex-column">
                                                <li className="nav-item">
                                                    <Link className="nav-link" to="Website-Desgn" >Home</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link" to="about">About</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link" to="services">Services</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link" to="work">Our Works</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link" to="contact">Contact Us</Link>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                    <div className="col-md-4 col-sm-6">
                                        <div className="footer-nav-wrap text-white">
                                            <h4 className="text-white">Services</h4>
                                            <ul className="nav flex-column">
                                                <li className="nav-item">
                                                    <a className="nav-link" href="https://dbcards.in">Digital Visiting Card</a>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link" to="website-design-development">Website Design & Development</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link" to="website-maintenance-service">Website Maintenance</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link" to="graphic-designing">Graphic Design</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link" to="social-media-marketing">Social Media Marketing</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link" to="seo-service">SEO (Search Engine Optimization)</Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-3">
                                <div className="row footer-top-wrap mt-md-4 mt-sm-0 mt-lg-0">
                                    <div className="col-12">
                                        <div className="footer-nav-wrap text-white">
                                            <h4 className="text-white">Contact Us</h4>
                                            <ul className="get-in-touch-list">
                                                <li className="d-flex align-items-center py-2"><span
                                                    className="fas fa-map-marker-alt mr-2"></span> Address: Mulund West Mumbai-400080 (India)
                                                </li>
                                                <li className="d-flex align-items-center py-2"><span
                                                    className="fas fa-envelope mr-2"></span> info@octaveinfosys.com
                                                </li>
                                                <li className="d-flex align-items-center py-2"><span
                                                    className="fas fa-phone-alt mr-2"></span> Phone: (+91) 9920341097 / 8080555597
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!--footer top end--> */}

                {/* <!--footer copyright start--> */}
                <div className="footer-bottom gray-light-bg py-2">
                    <div className="container">
                        <div className="row align-items-center justify-content-between">
                            <div className="col-md-5 col-lg-5">
                                <p className="copyright-text pb-0 mb-0">Copyrights © All
                                    rights reserved by
                                    <a href="https://octaveinfosys.com" rel="noreferrer" target="_blank"> Octave Infosys</a></p>
                            </div>
                            <div className="col-md-7 col-lg-6 d-none d-md-block d-lg-block">
                                <ul className="list-inline policy-nav text-right social-list">
                                    <li className="list-inline-item"><Link to="testimonial">Testimonials</Link></li>
                                    {/* <li className="list-inline-item"><a href="sitemap">Sitemap</a></li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!--footer copyright end--> */}
            </footer>
            {/* <!--footer section end--> */}

            {/* <!--bottom to top button start--> */}
            <button className="scroll-top scroll-to-target" data-target="html">
                <span className="ti-angle-up"></span>
            </button>
            {/* <!--bottom to top button end--> */}
        </>
    )
}

export default Footer
